import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AuthUser {
  id: string;
  email: string;
  name: string;
}

export interface AuthTenant {
  id: string;
  name?: string;
  role?: "admin" | "user" | "read_only";
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  tenant: AuthTenant | null;
  setTokens: (access: string, refresh: string) => void;
  setSession: (args: {
    accessToken: string;
    refreshToken: string;
    user: AuthUser;
    tenant: AuthTenant | null;
  }) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      tenant: null,
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setSession: ({ accessToken, refreshToken, user, tenant }) =>
        set({ accessToken, refreshToken, user, tenant }),
      clear: () =>
        set({ accessToken: null, refreshToken: null, user: null, tenant: null }),
    }),
    { name: "clearbooks.auth" }
  )
);
